import React, { Dispatch, SetStateAction } from 'react';
import Colors from '../../../constants/Colors';
import PressableStyled from '../../PressableStyled';
import CalendarIcon from '../../CalendarIcon';

interface CalendarIconButtonProps {
  dateSelected: boolean,
  logEvent,
  setDateSelected: Dispatch<SetStateAction<boolean>>,
  onOpen,
  testID?: string,
}

const CalendarIconButton = ({
  dateSelected, logEvent, setDateSelected, onOpen, testID = 'ticket-date-picker-btn',
}: CalendarIconButtonProps) => <PressableStyled
  style={{
    backgroundColor: dateSelected ? Colors.light.hereworksLightBlue : '#fff',
    width: 40,
    height: 40,
    borderWidth: 1.5,
    borderColor: dateSelected ? Colors.light.hereworksLightBlue : Colors.light.hereworksPaleBlue900,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  }}
  onPress={() => {
    onOpen(!dateSelected);
    setDateSelected(!dateSelected);
    logEvent('DateComponent', 'Calendar_Icon');
  }}
  {...{ testID }}
>
    <CalendarIcon color={dateSelected ? '#fff' : '#003A70'} />
  </PressableStyled>;

export default CalendarIconButton;
